<template>
  <el-dialog class="radish-dia" :title="title" top="70px" width="200px" :close-on-click-modal="false" :modal="false" :visible.sync="dialogVisible">
    <template v-if="withCheckAll" slot="title">
      <div>
        {{ title }}
        <el-checkbox v-model="checkAll" style="margin-left: 20px" @change="handleCheckAllChange">全选</el-checkbox>
      </div>
    </template>
    <div class="radish-dia-body">
      <div v-for="(v, k) in heads" :key="v.label + k"><input v-model="v.visible" type="checkbox" /> {{ v.label }}</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'main',
    },
    title: {
      type: String,
      default: '勾选要隐藏的列',
    },
    onConfirm: {
      type: Function,
      default: function() {},
    },
    storageName: {
      type: String,
      default: 'radishHeads',
    },
    withCheckAll: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      dialogVisible: false,
      heads: [],
      checkAll: true,
    }
  },
  watch: {
    heads: {
      immediate: true,
      deep: true,
      handler(oldVal, newVal) {
        // if (!this.withCheckAll) return
        this.checkAll = this.heads.every(h => h && h.visible)
      },
    },
  },
  methods: {
    show: function(heads) {
      this.heads = heads
      this.dialogVisible = true
    },
    handleConfirm: function() {
      let dt = {}
      for (const h of this.heads) {
        dt[h.label] = h.visible
      }
      dt = JSON.stringify(dt)
      localStorage[this.storageName] = dt
      this.onConfirm()
      this.dialogVisible = false
    },
    handleCheckAllChange(val) {
      this.heads.map(head => (head.visible = val))
    },
  },
}
</script>
